import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import {
  Button,
  CurrencyIcon,
  SheetClose,
  SheetTitle,
} from "@workspace/frontend-ui";
import { cva } from "class-variance-authority";
import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import useTranslations from "../../i18n/useTranslations";
import Pill from "../Pill";

type Props = {
  layout: "popover" | "sheet";
};

const titleVariants = cva("flex-1 font-semibold text-foreground", {
  variants: {
    layout: {
      popover: "text-base",
      sheet: "text-xl",
    },
  },
});

const RewardCenterHeader: FC<Props> = ({ layout }) => {
  const {
    state: { currency },
  } = useRewardCenter();
  const t = useTranslations();
  const title = t("reward_center.title");

  return (
    <div
      data-slot="reward-center-header"
      className="flex items-center gap-2.5 pl-1.5"
    >
      {layout === "sheet" ? (
        <SheetTitle className={titleVariants({ layout })}>{title}</SheetTitle>
      ) : (
        <p className={titleVariants({ layout })}>{title}</p>
      )}
      {currency && (
        <Pill>
          <CurrencyIcon currency={currency} />
          {currency}
        </Pill>
      )}
      {layout === "sheet" && (
        <SheetClose asChild>
          <Button
            variant="secondary"
            size="icon-lg"
            className="rounded-full [&_svg]:size-5"
          >
            <HugeiconsIcon icon={Cancel01Icon} />
          </Button>
        </SheetClose>
      )}
    </div>
  );
};

export default RewardCenterHeader;
